import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initAnalytics } from "./lib/analytics";

createRoot(document.getElementById("root")!).render(<App />);

// Defer analytics initialisation to after first paint.
// This prevents analytics SDK chunks (Sentry, PostHog, Mixpanel) from competing
// with critical page resources during initial load. On a throttled connection
// those ~200 KB chunks would otherwise start downloading immediately and cause
// long main-thread tasks when they finally evaluate 10-15 seconds later.
// requestIdleCallback fires during the browser's idle period after rendering;
// the 4-second timeout ensures init still happens on busy devices.
if (typeof requestIdleCallback !== "undefined") {
  requestIdleCallback(
    () => initAnalytics().catch((err) => console.warn("[LOCALE] Analytics init failed:", err)),
    { timeout: 4000 },
  );
} else {
  // Safari < 16 and older browsers don't support requestIdleCallback
  setTimeout(
    () => initAnalytics().catch((err) => console.warn("[LOCALE] Analytics init failed:", err)),
    1000,
  );
}
